// Load Bootstrap
import "../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

// Load JS Components
import './posts/loadmore';
import './zustand';

// Load Styles
import '../scss/main.scss';

// Load AOS for Animating Items
import AOS from 'aos';
AOS.init();
